import React from "react";
import {Card, Tabs} from "antd";
import MetadataDiffView from "./SubComponents/MetadataDiffView";

import ChangeInstanceExpandedTable from "./SubComponents/ChangeInstanceExpandedTable";

const SubmissionExpandedRow = ({ record }: { record: Record<string, any> }) => {
    return (
        <Card>
            <Tabs defaultActiveKey="1" type='card' items={[
                {
                    key: '1',
                    label: 'Change Instances',
                    children: <ChangeInstanceExpandedTable resource={"change_instances"} filterParam={{ submission_id: record.id, light: true }}/>,
                },
                {
                    key: '2',
                    label: 'Metadata',
                    children: <MetadataDiffView submission={record}/>,
                },
            ]} />
        </Card>
    );
}

export default SubmissionExpandedRow;
